import React from "react";
import PropTypes from "prop-types";
import { Button } from "cxa-components";

const CarouselNav = ({ currIdx = 0, noOfItems, onSelect, separator }) => (
  <p className="dashboard-header__actions">
    <Button
      secondary
      onClick={() => onSelect(currIdx - 1)}
      aria-label="Previous"
    >
      &lt;
    </Button>
    {" "}
    <span>
      {`${noOfItems ? currIdx + 1 : currIdx} ${separator} ${noOfItems}`}
    </span>
    {" "}
    <Button secondary onClick={() => onSelect(currIdx + 1)} aria-label="Next">
      &gt;
    </Button>
  </p>
);

CarouselNav.propTypes = {
  currIdx: PropTypes.number,
  noOfItems: PropTypes.number,
  onSelect: PropTypes.func,
  separator: PropTypes.any,
};

export default CarouselNav;



// WEBPACK FOOTER //
// ./components/dashboard/CarouselNav.js